// @flow

import React, { type Node } from 'react';
import { Button } from '../../../../atoms';
import { getSafeVoucherUrl, usePendingIncomingPayment } from '@tectonics/prs/incoming-payment';

export function PdfButton(): Node {
  const incomingPayment = usePendingIncomingPayment();
  const href = `${getSafeVoucherUrl(incomingPayment)}&format=pdf`;

  return (
    <Button
      as="a"
      block
      flat
      outline
      type="primary"
      size="lg"
      rel="noopener noreferrer"
      target="_blank"
      href={href}
    >
      Guardar comprobante
    </Button>
  );
}
